/**
 * List of versions that have release notes. Update this list when a new version is released, if it has release notes.
 * Release notes live in the `constants/releaseNotes` folder, written using Markdown.
 *
 * This is a short-term solution until we have a better way to handle release notes, possibly remotely.
 */
export const kVersionsWithReleaseNotes = [
  '0.75.0',
  '0.72.0',
  '0.71.0',
  '0.69.0',
  '0.68.0',
  '0.55.0',
  '0.43.0',
  '0.40.0',
  '0.33.0',
  '0.24.0',
]
